export default { data: [], status: "idle" };
